export function _mapNameIsSignificant(name) {//检验区块名称是否有意义
  return new RegExp("[MRPTS][0-9]+").test(name)
}

export function _pxGenerator(res) {
  let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  if (!clientWidth) return;
  let fontSize = 100 * (clientWidth / 1920);
  return res * fontSize;
}

export function getOrDefault(key, object, defaultValue) {
  if (object !== undefined && key in object) {
    return object[key]
  }
  return defaultValue
}

export function add(arg1, arg2) { // 加法
  let r1, r2, m
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}